document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('.theme-toggle');
    var label = document.querySelector('.theme-toggle__label'); function updateLabel() { if (!label) return; var current = document.documentElement.getAttribute('data-theme'); label.textContent = current === 'dark' ? 'Dark' : 'Light'; } updateLabel();
    if (toggle) {
    toggle.addEventListener('click', function () {
    var current = document.documentElement.getAttribute('data-theme');
    var next = current === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem('theme-mode', next); } catch (e) {} updateLabel();
    });
    }

    try {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
    if (!localStorage.getItem('theme-mode')) {
    document.documentElement.setAttribute('data-theme', e.matches ? 'dark' : 'light'); updateLabel();
    }
    });
    } catch (e) {}
    });
